import { getApigatewayBaseUrl, getAwsSessionEndpoint, getAwsSessionMethod } from 'utils/url';

const lazyApiClient = async () => import('@lessonnine/api-client.js').then((apiClientModule) => {
  const ApiClient = apiClientModule.default;
  return new ApiClient({
    baseUrl: getApigatewayBaseUrl(),
    awsSessionEndpoint: getAwsSessionEndpoint(),
    awsSessionMethod: getAwsSessionMethod().toLowerCase(),
  });
});

export default lazyApiClient;
